import Form from "../../../Form/Form";
import Input from "../../../Form/Input/Input";
import DefaultButton from "../../../../components/simple/DefaultButton";
import ToggleSwitch from "../../../Form/ToggleSwitch/ToggleSwitch";

const Notifications = ({ user, setLoading, setError }) => {
  const fields = [
    {
      label: "Notifications from your Guru",
      subText: "These are notifications from your Guru on X,Y & Z",
      fields: [
        {
          label: "WhatsApp",
          name: "notifications_whatsapp",
        },
        {
          label: "Email",
          name: "notifications_email",
        },
        {
          label: "SMS",
          name: "notifications_sms",
        },
      ],
    },
    {
      label: "Reminders",
      subText:
        "These are notifications to remind you of updates you might have missed.",
      fields: [
        {
          label: "WhatsApp",
          name: "reminders_whatsapp",
        },
        {
          label: "Email",
          name: "reminders_email",
        },
        {
          label: "SMS",
          name: "reminders_sms",
        },
      ],
    },
  ];

  return (
    <div className="profile-fields-container">
      <Form action="#">
        {({ register, formState: { errors }, control, getValues }) => (
          <>
            {fields.map((section, sectionIndex) => (
              <div key={sectionIndex} className="form-section">
                <label>
                  {section.label} <span>{section.subText}</span>
                </label>

                <div className="field-group-toggles">
                  {section.fields.map((field, fieldIndex) => (
                    <ToggleSwitch
                      key={fieldIndex}
                      label={field.label}
                      {...register(field.name)}
                      disabled
                    />
                  ))}
                </div>
              </div>
            ))}

            <div className="form-actions">
              <DefaultButton
                disabled
                buttonSize="md"
                wideOnMobile
                type="submit"
              >
                Save Changes
              </DefaultButton>
            </div>
          </>
        )}
      </Form>
    </div>
  );
};

export default Notifications;
